// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      asFoundConditionOptions: [
        "Trip",
        "Locked",
        "Broken",
        "Damage",
        "Smoke",
        "Fire",
        "Leak",
        "Spill",
        "Harm",
        "Injury",
        "Major",
        "Undefined"
      ]
    };
  }
};
